export default {
  GET_ALL: `#graphql
  query getEcommerceConfig {
    getEcommerceConfig {
      brand
      deliveryMinimum
      conveyorCostMetroZone
      conveyorCostOtherZone
      refundRequestMaxDays
      articles {
        article
      }
      sizes {
        type
        sizes {
          size
        }
      }
    }
  }`,

  UPDATE: `#graphql
  mutation updateEcommerceConfig($brand: String!, $articles: [EcommerceArticleInput]!, $sizes: [EcommerceSizeGroupInput]!, $deliveryMinimum: Float!, $conveyorCostMetroZone: Float!, $conveyorCostOtherZone: Float!, $refundRequestMaxDays: Int!) {
    updateEcommerceConfig(brand: $brand, articles: $articles, sizes: $sizes, deliveryMinimum: $deliveryMinimum, conveyorCostMetroZone: $conveyorCostMetroZone, conveyorCostOtherZone: $conveyorCostOtherZone, refundRequestMaxDays: $refundRequestMaxDays)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/ecommerceConfig.js